import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Player = Loadable({
    loader: () => import(/* webpackChunkName: "Player" */ './components/player/'),
    loading: () => <div />,
});
